import firebase from 'firebase/app'

export default {
  state: {
    user: null
  },
  getters: {
    user (state) {
      return state.user
    }
  },
  // synchronous
  mutations: {
    setUser (state, payload) {
      state.user = payload
    }
  },
  // asynchronous
  actions: {
    signUserUp ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(data => {
          // console.log(data)
          commit('setLoading', false)
          const newUser = {
            id: data.user.uid,
            email: data.user.email,
            name: payload.name,
            lastAccess: firebase.database.ServerValue.TIMESTAMP,
            createdAt: firebase.database.ServerValue.TIMESTAMP
          }
          commit('setUser', newUser)
          return firebase.database().ref('users').child(newUser.id).set(newUser)
        })
        .then(() => {
          return firebase.auth().currentUser.updateProfile({
            displayName: payload.name
          })
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    },
    signUserIn ({ commit }, payload) {
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(data => {
          // console.log(data)
          commit('setLoading', false)
          const newUser = {
            id: data.user.uid,
            email: data.user.email,
            name: data.user.displayName
          }
          commit('setUser', newUser)
          return firebase.database().ref('users').child(newUser.id).update({
            lastAccess: firebase.database.ServerValue.TIMESTAMP
          })
        })
        .then(() => {
        })
        .catch(err => {
          console.log(err)
          commit('setLoading', false)
          commit('setError', err.message)
        })
    },
    signUserOut ({ commit }) {
      // console.log('sign user out')
      firebase.auth().signOut()
      commit('setUser', null)
    },
    autoSignUserIn ({ commit }, payload) {
      // console.log('auto sign user in')
      // console.log(payload)
      commit('setUser', {
        id: payload.uid,
        email: payload.email,
        name: payload.displayName
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth/index.js